import React from 'react';
import '../style.scss';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishCheck } from 'views/components/atoms/establishes/check';
import { EstablishLink } from 'views/components/atoms/establishes/link';
import { EstablishError } from 'views/components/atoms/establishes/error';

export type InputConsentProps = {
  title: string;
  name: string;
  checkText: string;
  linkTitle?: string;
  linkUrl?: string;
  onClickLink?: () => void;
  isChecked: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEnable: boolean;
  errorText?: string;
  batchDangerWord?: string;
};

export const InputConsent = (props: InputConsentProps) => {
  const {
    title,
    name,
    checkText,
    linkTitle,
    linkUrl,
    onClickLink,
    isChecked,
    setIsChecked,
    isEnable,
    errorText,
    batchDangerWord,
  } = props;
  return (
    <div className="inputWrapper">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <fieldset className={name}>
        <EstablishCheck name={name} text={checkText} isChecked={isChecked} setIsChecked={setIsChecked} />
      </fieldset>
      <EstablishLink linkTitle={linkTitle} linkUrl={linkUrl} onClick={onClickLink} />
      <EstablishError isEnabled={isEnable} errorText={errorText} />
    </div>
  );
};
